import { useQuery } from '@apollo/client'
import { Link, useHistory } from 'react-router-dom'
import { Flex, Text } from 'rebass/styled-components'
import { IonPage, IonLoading, IonItem, IonLabel, IonIcon } from '@ionic/react'
import { chevronForwardOutline } from 'ionicons/icons'

import Header from '../../components/Header'
import { CUSTOMER_INFO } from '../../graphql/queries'
import { storage } from '../../utils/index'
import IonContent from '../../components/IonContent'

const datas = [
    {
        title: 'Orders',
        link: '/order',
    },
    {
        title: 'Address',
        link: '/address',
    },
    {
        title: 'Service',
        link: '/privacy?type=terms',
    },
    {
        title: 'Privacy',
        link: '/privacy',
    },
]

export default () => {
    const token = storage.getItem('accessToken')
    const { data, loading } = useQuery(CUSTOMER_INFO, {
        variables: {
            customerAccessToken: token,
        },
    })

    const history = useHistory()
    const handleLogout = () => {
        localStorage.accessToken = ''
        history.push('/login')
    }

    return (
        <IonPage>
            <Header title="User"></Header>
            <IonContent fullscreen>
                <Flex
                    justifyContent="center"
                    alignItems="center"
                    py="50px"
                    bg="primary"
                    flexDirection="column"
                >
                    <Flex
                        width="80px"
                        height="80px"
                        justifyContent="center"
                        alignItems="center"
                        bg="secondary"
                        css={{
                            borderRadius: '50%',
                            border: '1px solid #eee',
                        }}
                    >
                        <Text color="white">Hello</Text>
                    </Flex>
                    {data?.customer ? (
                        <Flex>
                            <Text color="white" mt="20px">
                                {data?.customer?.email}
                            </Text>
                        </Flex>
                    ) : (
                        <Flex mt="20px">
                            {['Register', 'Login'].map((x) => (
                                <Link to={`/${x.toLowerCase()}`}>
                                    <Text mx="10px" color="white">
                                        {x}
                                    </Text>
                                </Link>
                            ))}
                        </Flex>
                    )}
                </Flex>
                {datas.map((x) => (
                    <Link to={x.link}>
                        <IonItem>
                            <IonLabel>{x.title}</IonLabel>
                            <Flex color="#999">
                                <IonIcon slot="end" icon={chevronForwardOutline}></IonIcon>
                            </Flex>
                        </IonItem>
                    </Link>
                ))}

                {data?.customer && (
                    <IonItem onClick={handleLogout}>
                        <IonLabel>Logout</IonLabel>
                    </IonItem>
                )}
                <IonLoading isOpen={loading}></IonLoading>
            </IonContent>
        </IonPage>
    )
}
